import gql from "graphql-tag";

export const ORDERS = gql`
  query orders ($first: Int, $after: String, $status: OrderStatusFilter) {
    orders(first: $first, after: $after, status: $status) {
      totalCount
      pageInfo {
        startCursor
      }
      edges {
        node {
          id
          number
          token
          total {
            gross {
              amount
            }
          }
          created
          isPaid
          paymentStatus
          paymentStatusDisplay
          status
          statusDisplay
        }
      }
    }
  }
`;
